export const EmployeeStatusesEnum = {
  Active: {
    key: 1,
    value: 'active',
  },
  Suspended: {
    key: 2,
    value: 'suspended',
  },
  OnLeave: {
    key: 3,
    value: 'on-leave',
  },
};
